module.exports = __webpack_public_path__ + "static/media/PDF_106.dcc1dc4a.pdf";